export const DELIVERABLES = "SET_DELIVERABLES";
export const DRAFT_DELIVERABLES = "SET_DRAFT_DELIVERABLES";
export const LISTED_DELIVERABLES_PER_PAGE = "SET_LISTED_DELIVERABLES_PER_PAGE";
export const LISTED_DELIVERABLES_PAGINATION =
	"SET_LISTED_DELIVERABLES_PAGINATION";
export const DRAFT_ABTESTS = "DRAFT_ABTESTS";
export const ACTIVE_ABTESTS = "ACTIVE_ABTESTS";
export const COMPLETED_ABTESTS = "COMPLETED_ABTESTS";

export const setDeliverables = (deliverables) => {
	return {
		type: DELIVERABLES,
		deliverables,
	};
};

export const setDraftDeliverables = (draftDeliverables) => {
	return {
		type: DRAFT_DELIVERABLES,
		draftDeliverables,
	};
};
export const setActiveABTests = (abTests) => {
	return {
		type: ACTIVE_ABTESTS,
		abTests,
	};
};
export const setCompletedABTests = (abTests) => {
	return {
		type: COMPLETED_ABTESTS,
		abTests,
	};
};
export const setDraftABTests = (draftABTests) => {
	return {
		type: DRAFT_ABTESTS,
		draftABTests,
	};
};

export const setListedDeliverablesPerPage = (perPage) => {
	return {
		type: LISTED_DELIVERABLES_PER_PAGE,
		perPage,
	};
};

export const setListedDeliverablesPagination = (page) => {
	return {
		type: LISTED_DELIVERABLES_PAGINATION,
		page,
	};
};
